import { render } from "./EghdamatDolat.vue?vue&type=template&id=68a672ae&scoped=true"
import script from "./EghdamatDolat.vue?vue&type=script&lang=js"
export * from "./EghdamatDolat.vue?vue&type=script&lang=js"

import "./EghdamatDolat.vue?vue&type=style&index=0&id=68a672ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a672ae"]])

export default __exports__